import { COMPONENT_NAME as CONFIRMATION_POPUP_COMPONENT_NAME, IMRConfirmationPopupComponent } from './confirmation-popup.component'

export const CONFIRMATION_POPUP_MODULE_NAME = 'simax.common.confirmation-popup'

const module = angular.module(CONFIRMATION_POPUP_MODULE_NAME, [])

module.component(CONFIRMATION_POPUP_COMPONENT_NAME, new IMRConfirmationPopupComponent())
